/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IaaCProjectRoleDTO } from './IaaCProjectRoleDTO';
import {
    IaaCProjectRoleDTOFromJSON,
    IaaCProjectRoleDTOFromJSONTyped,
    IaaCProjectRoleDTOToJSON,
} from './IaaCProjectRoleDTO';

/**
 * 
 * @export
 * @interface IaaCProjectMemberUpdateDTO
 */
export interface IaaCProjectMemberUpdateDTO {
    /**
     * 
     * @type {IaaCProjectRoleDTO}
     * @memberof IaaCProjectMemberUpdateDTO
     */
    role: IaaCProjectRoleDTO;
}



/**
 * Check if a given object implements the IaaCProjectMemberUpdateDTO interface.
 */
export function instanceOfIaaCProjectMemberUpdateDTO(value: object): value is IaaCProjectMemberUpdateDTO {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function IaaCProjectMemberUpdateDTOFromJSON(json: any): IaaCProjectMemberUpdateDTO {
    return IaaCProjectMemberUpdateDTOFromJSONTyped(json, false);
}

export function IaaCProjectMemberUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IaaCProjectMemberUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'role': IaaCProjectRoleDTOFromJSON(json['role']),
    };
}

export function IaaCProjectMemberUpdateDTOToJSON(value?: IaaCProjectMemberUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': IaaCProjectRoleDTOToJSON(value['role']),
    };
}

